import {Component, Vue} from 'vue-property-decorator';
import RoundedButton from '@/components/RoundedButton/RoundedButton.vue';
import StepperFlow from '@/services/StepperFlow';
import Logger from '@/services/Logger';


declare global {
  interface Window {
    MobiKey: any;
  }
}


@Component({
  components: {RoundedButton},
})


export default class Keywords extends Vue {

  public showCongratulationModal = false;
  public offer = "loans";


  public mounted() {
    let self = this;


    if ((this.$route.query && this.$route.query.geo && (this.$route.query.geo == "gb" || this.$route.query.geo == "uk"))) {

      this.offer = "cv-distribution";

    } else if ((this.$route.query && this.$route.query.isLoan && this.$route.query.isLoan == "true") || (this.$route.query && this.$route.query.botName && this.$route.query.botName == "adview")) {
      const queryParams = new URLSearchParams();
      const paramsObj = {
        ...this.$route.query,
        q: StepperFlow.keywords[0] + " jobs",
        utm_source: 'web-push',
      } as any;
      Object.keys(paramsObj).forEach((key) => queryParams.set(key, paramsObj[key]));

      var url = `${process.env.VUE_APP_REDIRECT_URL}/?${queryParams}`;
      var bingUrl = `https://trends.mobitech-search.xyz/v1/search/${window.MobiKey}?user_id=${paramsObj.uid}&q=${paramsObj.q}`;
      console.log("do redirect", bingUrl);
      window.location.replace(bingUrl);
    }

  }

  public handleSubmitCv() {
    Logger.logCvDClick();


    const queryParams = new URLSearchParams();
    const {geo = 'us'} = this.$route.query;

    const paramsObj = {
      ...this.$route.query,
      q: StepperFlow.keywords[0] + " jobs",
      utm_source: 'web-push',
    } as any;

    Object.keys(paramsObj).forEach((key) => queryParams.set(key, paramsObj[key]));
    var url = `${process.env.VUE_APP_REDIRECT_URL}/?${queryParams}`;
    var bingUrlJobs = `https://trends.mobitech-search.xyz/v1/search/${window.MobiKey}?user_id=${paramsObj.uid}&q=${paramsObj.q}`;
    var nextcareernowUrl = `https://nextcareernow.com/?${queryParams}`;

    //console.log("nextcareernowUrl ", nextcareernowUrl);

    var cvdUrl = "https://www.cv-library.co.uk/register?id=103167";

    if (this.$route.query && this.$route.query.botName == "fb") {
      cvdUrl = "https://www.cv-library.co.uk/aff/103465";
    } else if (this.$route.query && this.$route.query.botName == "adview") {
      cvdUrl = "https://www.cv-library.co.uk/aff/103468"
    }

    //alert(cvdUrl);


    window.open(cvdUrl, '_blank');
    //window.open(url, '_blank');
    //window.location.replace("https://d2s.olympuswaymarketing.com/search?q=loan&sid=8899");
    window.location.replace(nextcareernowUrl);

  }

  public handleSubmit() {
    Logger.logGetQuoteClick();
    StepperFlow.saveIsLoan(true);

    if (process.env.VUE_APP_REDIRECT_URL) {
      const queryParams = new URLSearchParams();
      const {geo = 'us'} = this.$route.query;

      const paramsObj = {
        ...this.$route.query,
        q: StepperFlow.keywords[0] + " jobs",
        utm_source: 'web-push',
      } as any;

      Object.keys(paramsObj).forEach((key) => queryParams.set(key, paramsObj[key]));
      var url = `${process.env.VUE_APP_REDIRECT_URL}/?${queryParams}`;
      //var url = `https://nextcareernow.com/results/?${queryParams}`;
      var yahooUrl = `https://nextcareernow.com/?${queryParams}`;
      //var bingUrl = "http://search.nvxmn.info/c/9jRMBDzjpPDLxwQE?src=dp&tg1=10548&tg2=jobs-bear&pub=jobs-bear.com&kw=loans%2CPersonal+loans%2CFree+creadit+score+check";
      var bingUrl = "https://myfirsttab.com/api/redirect-search?sid=11793&cid=jobs&t=Loans";


      window.open(bingUrl, '_blank');
      //window.open("https://nextcareernow.com/loans.html?q=loans", '_blank');
      //window.open(url, '_blank');
      //window.location.replace("https://d2s.olympuswaymarketing.com/search?q=loan&sid=8899");
      window.location.replace(yahooUrl);

    }

  }

  public handleNoThankYou() {
    Logger.logClickNoThankYou();
    StepperFlow.saveIsLoan(false)
      .then(this.showRedirectModal);

    if (process.env.VUE_APP_REDIRECT_URL) {
      const queryParams = new URLSearchParams();
      const {geo = 'us'} = this.$route.query;

      const paramsObj = {
        ...this.$route.query,
        q: StepperFlow.keywords[0] + " jobs",
        utm_source: 'web-push',
      } as any;

      Object.keys(paramsObj).forEach((key) => queryParams.set(key, paramsObj[key]));
      var url = `${process.env.VUE_APP_REDIRECT_URL}/?${queryParams}`;
      //window.open(url, '_blank');
      //window.location.replace("https://d2s.olympuswaymarketing.com/search?q=" + StepperFlow.keywords[0] + " jobs" + "&sid=8899");
      var yahooUrl = `https://nextcareernow.com/?${queryParams}`;
      var bingUrl = `https://trends.mobitech-search.xyz/v1/search/${window.MobiKey}?user_id=${paramsObj.uid}&q=${paramsObj.q}`;
      var nextcareernowUrl = `https://nextcareernow.com/?${queryParams}`;

      if (this.$route.query.geo == "gb" || this.$route.query.geo == "us" || this.$route.query.geo == "ca") {

      }

      window.open(yahooUrl, '_blank');
      //window.location.replace(url);

      /*if ((this.$route.query && this.$route.query.botName && this.$route.query.botName == "adview")) {
        window.location.replace(url);
      } else {
        window.open(url, '_blank');
        window.location.replace("https://go.onclasrv.com/afu.php?zoneid=2004816");
      }*/


    }
  }

  private showRedirectModal() {
    this.showCongratulationModal = true;


    setTimeout(() => {

    }, 2000);
  }


}
